import AboutUs from "./Components/AboutUs/AboutUs";
import Footer from "./Components/Footer/Footer";
import HeroSec from "./Components/Header/HeroSec";
import Navbar from "./Components/Header/Navbar";
function App() {
  return (
    <>
      <Navbar />
      <HeroSec />
      <AboutUs />
      <Footer />
    </>
  );
}

export default App;
